var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstitutions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 82,
    viewBox: "0 0 138 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.262 24.1055H2.85522V78.8398H135.262V24.1055Z",
    fill: "#1F8297"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.567 22.6953H0V26.4582H137.567V22.6953Z",
    fill: "#4D7479"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.666 3.57422H35.7913V78.843H101.666V3.57422Z",
    fill: "#4C9BAC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.666 0H35.7913V3.57469H101.666V0Z",
    fill: "#4D7479"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1792 31.9258H7.47925V40.7827H16.1792V31.9258Z",
    fill: "#B0BABA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3498 31.9258L7.47925 35.7029V39.6144L16.1792 35.2309V31.9258H14.3498Z",
    fill: "#F3F5F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47998 40.1086L16.1799 35.7695V36.5565L7.47998 40.7822V40.1086Z",
    fill: "#F3F5F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1303 31.9258H11.4205V40.7827H12.1303V31.9258Z",
    fill: "#F7A47A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1792 36.0117H7.47925V36.7315H16.1792V36.0117Z",
    fill: "#F7A47A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1801 31.1445H7.48022V31.9425H16.1801V31.1445Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47887 31.1445H6.69019V40.7994H7.47887V31.1445Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0191 31.1445H16.1792V40.7994H17.0191V31.1445Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0196 40.7852H6.69019V41.7267H17.0196V40.7852Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0129 31.9258H21.313V40.7827H30.0129V31.9258Z",
    fill: "#B0BABA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1835 31.9258L21.313 35.7029V39.6144L30.0129 35.2309V31.9258H28.1835Z",
    fill: "#F3F5F5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3125 40.1086L30.0124 35.7695V36.5565L21.3125 40.7822V40.1086Z",
    fill: "#F3F5F5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.964 31.9258H25.2543V40.7827H25.964V31.9258Z",
    fill: "#F7A47A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0128 36.0117H21.3129V36.7315H30.0128V36.0117Z",
    fill: "#F7A47A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0127 31.1445H21.3127V31.9425H30.0127V31.1445Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.313 31.1445H20.5243V40.7994H21.313V31.1445Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8529 31.1445H30.0129V40.7994H30.8529V31.1445Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8537 40.7852H20.5243V41.7267H30.8537V40.7852Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1801 46.0352H7.48022V54.8921H16.1801V46.0352Z",
    fill: "#B0BABA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3508 46.0352L7.48022 49.8123V53.7238L16.1801 49.3403V46.0352H14.3508Z",
    fill: "#F3F5F5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48022 54.2219L16.1801 49.8828V50.6698L7.48022 54.8955V54.2219Z",
    fill: "#F3F5F5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1301 46.0352H11.4204V54.8921H12.1301V46.0352Z",
    fill: "#F7A47A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1792 50.1211H7.47925V50.8401H16.1792V50.1211Z",
    fill: "#F7A47A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1801 45.2539H7.48022V46.0518H16.1801V45.2539Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47887 45.2539H6.69019V54.9088H7.47887V45.2539Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0191 45.2539H16.1792V54.9088H17.0191V45.2539Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0196 54.8945H6.69019V55.8361H17.0196V54.8945Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0127 46.0352H21.3127V54.8921H30.0127V46.0352Z",
    fill: "#B0BABA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1833 46.0352L21.3127 49.8123V53.7238L30.0127 49.3403V46.0352H28.1833Z",
    fill: "#F3F5F5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3127 54.2219L30.0127 49.8828V50.6698L21.3127 54.8955V54.2219Z",
    fill: "#F3F5F5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M25.964 46.0352H25.2543V54.8921H25.964V46.0352Z",
    fill: "#F7A47A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0128 50.1211H21.3129V50.8401H30.0128V50.1211Z",
    fill: "#F7A47A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0127 45.2539H21.3127V46.0518H30.0127V45.2539Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M21.313 45.2539H20.5243V54.9088H21.313V45.2539Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8529 45.2539H30.0129V54.9088H30.8529V45.2539Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8537 54.8945H20.5243V55.8361H30.8537V54.8945Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M16.18 60.1484H7.4801V69.0054H16.18V60.1484Z",
    fill: "#B0BABA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3507 60.1484L7.4801 63.9256V67.8371L16.18 63.4535V60.1484H14.3507Z",
    fill: "#F3F5F5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4801 68.3156L16.18 63.9766V64.7636L7.4801 68.9892V68.3156Z",
    fill: "#F3F5F5"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M12.13 60.1484H11.4203V69.0054H12.13V60.1484Z",
    fill: "#F7A47A"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M16.18 64.2383H7.4801V64.9581H16.18V64.2383Z",
    fill: "#F7A47A"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1799 59.3477H7.47998V60.1456H16.1799V59.3477Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47875 59.3477H6.69006V69.0026H7.47875V59.3477Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0194 59.3477H16.1794V69.0026H17.0194V59.3477Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0194 69.0078H6.69006V69.9493H17.0194V69.0078Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0127 60.1484H21.3127V69.0054H30.0127V60.1484Z",
    fill: "#B0BABA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1833 60.1484L21.3127 63.9256V67.8371L30.0127 63.4535V60.1484H28.1833Z",
    fill: "#F3F5F5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3127 68.3156L30.0127 63.9766V64.7636L21.3127 68.9892V68.3156Z",
    fill: "#F3F5F5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M25.964 60.1484H25.2543V69.0054H25.964V60.1484Z",
    fill: "#F7A47A"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0127 64.2383H21.3127V64.9581H30.0127V64.2383Z",
    fill: "#F7A47A"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0124 59.3477H21.3125V60.1456H30.0124V59.3477Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3132 59.3477H20.5245V69.0026H21.3132V59.3477Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M30.853 59.3477H30.0131V69.0026H30.853V59.3477Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8537 69.0078H20.5243V69.9493H30.8537V69.0078Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M129.482 31.9258H120.782V40.7827H129.482V31.9258Z",
    fill: "#B0BABA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M127.653 31.9258L120.782 35.7029V39.6144L129.482 35.2309V31.9258H127.653Z",
    fill: "#F3F5F5"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M120.782 40.1086L129.482 35.7695V36.5565L120.782 40.7822V40.1086Z",
    fill: "#F3F5F5"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M125.434 31.9258H124.724V40.7827H125.434V31.9258Z",
    fill: "#F7A47A"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M129.482 36.0117H120.782V36.7315H129.482V36.0117Z",
    fill: "#F7A47A"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M129.482 31.1445H120.782V31.9425H129.482V31.1445Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M120.782 31.1445H119.993V40.7994H120.782V31.1445Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M130.322 31.1445H129.482V40.7994H130.322V31.1445Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M130.323 40.7852H119.993V41.7267H130.323V40.7852Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M129.482 46.0352H120.782V54.8921H129.482V46.0352Z",
    fill: "#B0BABA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M127.653 46.0352L120.782 49.8123V53.7238L129.482 49.3403V46.0352H127.653Z",
    fill: "#F3F5F5"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M120.782 54.2219L129.482 49.8828V50.6698L120.782 54.8955V54.2219Z",
    fill: "#F3F5F5"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M125.434 46.0352H124.724V54.8921H125.434V46.0352Z",
    fill: "#F7A47A"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M129.482 50.1211H120.782V50.8401H129.482V50.1211Z",
    fill: "#F7A47A"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M129.482 45.2539H120.782V46.0518H129.482V45.2539Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M120.782 45.2539H119.993V54.9088H120.782V45.2539Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M130.322 45.2539H129.482V54.9088H130.322V45.2539Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M130.323 54.8945H119.993V55.8361H130.323V54.8945Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M129.482 60.1484H120.782V69.0054H129.482V60.1484Z",
    fill: "#B0BABA"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M127.653 60.1484L120.782 63.9256V67.8371L129.482 63.4535V60.1484H127.653Z",
    fill: "#F3F5F5"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M120.782 68.3156L129.482 63.9766V64.7636L120.782 68.9892V68.3156Z",
    fill: "#F3F5F5"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M125.434 60.1484H124.724V69.0054H125.434V60.1484Z",
    fill: "#F7A47A"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M129.482 64.2383H120.782V64.9581H129.482V64.2383Z",
    fill: "#F7A47A"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M129.482 59.3477H120.782V60.1456H129.482V59.3477Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M120.782 59.3477H119.993V69.0026H120.782V59.3477Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M130.322 59.3477H129.482V69.0026H130.322V59.3477Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M130.323 69.0078H119.993V69.9493H130.323V69.0078Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M135.262 75.8633H2.85522V78.8408H135.262V75.8633Z",
    fill: "#4D7479"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7919 26.4531H2.85522V28.8923H35.7919V26.4531Z",
    fill: "#69ABB9"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M135.262 26.4531H101.666V28.8923H135.262V26.4531Z",
    fill: "#69ABB9"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M101.666 0H35.7913V1.78735H101.666V0Z",
    fill: "#1F8297"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7916 22.6953H0V24.5767H35.7916V22.6953Z",
    fill: "#1F8297"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M137.567 22.6953H101.666V24.5767H137.567V22.6953Z",
    fill: "#1F8297"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M46.71 3.98047H37.2206V6.40281H46.71V3.98047Z",
    fill: "#98C6CF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6138 7.33984H38.1244V9.76218H47.6138V7.33984Z",
    fill: "#98C6CF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M46.71 10.6992H37.2206V13.1216H46.71V10.6992Z",
    fill: "#98C6CF"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4214 14.0625H39.9319V16.4848H49.4214V14.0625Z",
    fill: "#98C6CF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M46.71 17.418H37.2206V19.8403H46.71V17.418Z",
    fill: "#98C6CF"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M46.71 20.7812H37.2206V23.2036H46.71V20.7812Z",
    fill: "#98C6CF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5169 24.1367H39.0283V26.5591H48.5169V24.1367Z",
    fill: "#98C6CF"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M46.71 27.5H37.2206V29.9223H46.71V27.5Z",
    fill: "#98C6CF"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1034 3.94141H47.6139V6.36374H57.1034V3.94141Z",
    fill: "#98C6CF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0072 7.30078H48.5177V9.72312H58.0072V7.30078Z",
    fill: "#98C6CF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1034 10.6602H47.6139V13.0825H57.1034V10.6602Z",
    fill: "#98C6CF"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8146 14.0234H50.3252V16.4458H59.8146V14.0234Z",
    fill: "#98C6CF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1034 17.3789H47.6139V19.8012H57.1034V17.3789Z",
    fill: "#98C6CF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1034 20.7422H47.6139V23.1645H57.1034V20.7422Z",
    fill: "#98C6CF"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9111 24.0977H49.4216V26.52H58.9111V24.0977Z",
    fill: "#98C6CF"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1034 27.4609H47.6139V29.8833H57.1034V27.4609Z",
    fill: "#98C6CF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7141 3.98047H58.2246V6.40281H67.7141V3.98047Z",
    fill: "#98C6CF"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6179 7.33984H59.1284V9.76218H68.6179V7.33984Z",
    fill: "#98C6CF"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7141 10.6992H58.2246V13.1216H67.7141V10.6992Z",
    fill: "#98C6CF"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4253 14.0625H60.9359V16.4848H70.4253V14.0625Z",
    fill: "#98C6CF"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7141 17.418H58.2246V19.8403H67.7141V17.418Z",
    fill: "#98C6CF"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7141 20.7812H58.2246V23.2036H67.7141V20.7812Z",
    fill: "#98C6CF"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5218 24.1367H60.0323V26.5591H69.5218V24.1367Z",
    fill: "#98C6CF"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7141 27.5H58.2246V29.9223H67.7141V27.5Z",
    fill: "#98C6CF"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1071 3.94141H68.6177V6.36374H78.1071V3.94141Z",
    fill: "#98C6CF"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M79.01 7.30078H69.5206V9.72312H79.01V7.30078Z",
    fill: "#98C6CF"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1071 10.6602H68.6177V13.0825H78.1071V10.6602Z",
    fill: "#98C6CF"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8177 14.0234H71.3282V16.4458H80.8177V14.0234Z",
    fill: "#98C6CF"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1071 17.3789H68.6177V19.8012H78.1071V17.3789Z",
    fill: "#98C6CF"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1071 20.7422H68.6177V23.1645H78.1071V20.7422Z",
    fill: "#98C6CF"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9136 24.0977H70.4242V26.52H79.9136V24.0977Z",
    fill: "#98C6CF"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1071 27.4609H68.6177V29.8833H78.1071V27.4609Z",
    fill: "#98C6CF"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2494 3.98047H78.76V6.40281H88.2494V3.98047Z",
    fill: "#98C6CF"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1532 7.33984H79.6638V9.76218H89.1532V7.33984Z",
    fill: "#98C6CF"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2494 10.6992H78.76V13.1216H88.2494V10.6992Z",
    fill: "#98C6CF"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9608 14.0625H81.4713V16.4848H90.9608V14.0625Z",
    fill: "#98C6CF"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2494 17.418H78.76V19.8403H88.2494V17.418Z",
    fill: "#98C6CF"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2494 20.7812H78.76V23.2036H88.2494V20.7812Z",
    fill: "#98C6CF"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0572 24.1367H80.5677V26.5591H90.0572V24.1367Z",
    fill: "#98C6CF"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2494 27.5H78.76V29.9223H88.2494V27.5Z",
    fill: "#98C6CF"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6425 3.94141H89.1531V6.36374H98.6425V3.94141Z",
    fill: "#98C6CF"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5455 7.30078H90.056V9.72312H99.5455V7.30078Z",
    fill: "#98C6CF"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6425 10.6602H89.1531V13.0825H98.6425V10.6602Z",
    fill: "#98C6CF"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M101.354 14.0234H91.8644V16.4458H101.354V14.0234Z",
    fill: "#98C6CF"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6425 17.3789H89.1531V19.8012H98.6425V17.3789Z",
    fill: "#98C6CF"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6425 20.7422H89.1531V23.1645H98.6425V20.7422Z",
    fill: "#98C6CF"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M100.449 24.0977H90.96V26.52H100.449V24.0977Z",
    fill: "#98C6CF"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6425 27.4609H89.1531V29.8833H98.6425V27.4609Z",
    fill: "#98C6CF"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M46.71 31.7031H37.2206V34.1255H46.71V31.7031Z",
    fill: "#98C6CF"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6138 35.0625H38.1244V37.4848H47.6138V35.0625Z",
    fill: "#98C6CF"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M46.71 38.4219H37.2206V40.8442H46.71V38.4219Z",
    fill: "#98C6CF"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4214 41.7852H39.9319V44.2075H49.4214V41.7852Z",
    fill: "#98C6CF"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M46.71 45.1406H37.2206V47.563H46.71V45.1406Z",
    fill: "#98C6CF"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M46.71 48.5039H37.2206V50.9263H46.71V48.5039Z",
    fill: "#98C6CF"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5169 51.8594H39.0283V54.2817H48.5169V51.8594Z",
    fill: "#98C6CF"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M46.71 55.2227H37.2206V57.645H46.71V55.2227Z",
    fill: "#98C6CF"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1034 31.6641H47.6139V34.0864H57.1034V31.6641Z",
    fill: "#98C6CF"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0072 35.0234H48.5177V37.4458H58.0072V35.0234Z",
    fill: "#98C6CF"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1034 38.3828H47.6139V40.8052H57.1034V38.3828Z",
    fill: "#98C6CF"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8146 41.7461H50.3252V44.1684H59.8146V41.7461Z",
    fill: "#98C6CF"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1034 45.1016H47.6139V47.5239H57.1034V45.1016Z",
    fill: "#98C6CF"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1034 48.4648H47.6139V50.8872H57.1034V48.4648Z",
    fill: "#98C6CF"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9111 51.8203H49.4216V54.2426H58.9111V51.8203Z",
    fill: "#98C6CF"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1034 55.1836H47.6139V57.6059H57.1034V55.1836Z",
    fill: "#98C6CF"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7141 31.7031H58.2246V34.1255H67.7141V31.7031Z",
    fill: "#98C6CF"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6179 35.0625H59.1284V37.4848H68.6179V35.0625Z",
    fill: "#98C6CF"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7141 38.4219H58.2246V40.8442H67.7141V38.4219Z",
    fill: "#98C6CF"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4253 41.7852H60.9359V44.2075H70.4253V41.7852Z",
    fill: "#98C6CF"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7141 45.1406H58.2246V47.563H67.7141V45.1406Z",
    fill: "#98C6CF"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7141 48.5039H58.2246V50.9263H67.7141V48.5039Z",
    fill: "#98C6CF"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5218 51.8594H60.0323V54.2817H69.5218V51.8594Z",
    fill: "#98C6CF"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7141 55.2227H58.2246V57.645H67.7141V55.2227Z",
    fill: "#98C6CF"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1071 31.6641H68.6177V34.0864H78.1071V31.6641Z",
    fill: "#98C6CF"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M79.01 35.0234H69.5206V37.4458H79.01V35.0234Z",
    fill: "#98C6CF"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1071 38.3828H68.6177V40.8052H78.1071V38.3828Z",
    fill: "#98C6CF"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8177 41.7461H71.3282V44.1684H80.8177V41.7461Z",
    fill: "#98C6CF"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1071 45.1016H68.6177V47.5239H78.1071V45.1016Z",
    fill: "#98C6CF"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1071 48.4648H68.6177V50.8872H78.1071V48.4648Z",
    fill: "#98C6CF"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9136 51.8203H70.4242V54.2426H79.9136V51.8203Z",
    fill: "#98C6CF"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1071 55.1836H68.6177V57.6059H78.1071V55.1836Z",
    fill: "#98C6CF"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2494 31.7031H78.76V34.1255H88.2494V31.7031Z",
    fill: "#98C6CF"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1532 35.0625H79.6638V37.4848H89.1532V35.0625Z",
    fill: "#98C6CF"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2494 38.4219H78.76V40.8442H88.2494V38.4219Z",
    fill: "#98C6CF"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9608 41.7852H81.4713V44.2075H90.9608V41.7852Z",
    fill: "#98C6CF"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2494 45.1406H78.76V47.563H88.2494V45.1406Z",
    fill: "#98C6CF"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2494 48.5039H78.76V50.9263H88.2494V48.5039Z",
    fill: "#98C6CF"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0572 51.8594H80.5677V54.2817H90.0572V51.8594Z",
    fill: "#98C6CF"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2494 55.2227H78.76V57.645H88.2494V55.2227Z",
    fill: "#98C6CF"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6425 31.6641H89.1531V34.0864H98.6425V31.6641Z",
    fill: "#98C6CF"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5455 35.0234H90.056V37.4458H99.5455V35.0234Z",
    fill: "#98C6CF"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6425 38.3828H89.1531V40.8052H98.6425V38.3828Z",
    fill: "#98C6CF"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M101.354 41.7461H91.8644V44.1684H101.354V41.7461Z",
    fill: "#98C6CF"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6425 45.1016H89.1531V47.5239H98.6425V45.1016Z",
    fill: "#98C6CF"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6425 48.4648H89.1531V50.8872H98.6425V48.4648Z",
    fill: "#98C6CF"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M100.449 51.8203H90.96V54.2426H100.449V51.8203Z",
    fill: "#98C6CF"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6425 55.1836H89.1531V57.6059H98.6425V55.1836Z",
    fill: "#98C6CF"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0402 59.4023H36.5508V61.8247H46.0402V59.4023Z",
    fill: "#98C6CF"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M46.944 62.7617H37.4546V65.1841H46.944V62.7617Z",
    fill: "#98C6CF"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0402 66.1211H36.5508V68.5435H46.0402V66.1211Z",
    fill: "#98C6CF"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7518 69.4844H39.2623V71.9067H48.7518V69.4844Z",
    fill: "#98C6CF"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4328 59.3672H46.9442V61.7895H56.4328V59.3672Z",
    fill: "#98C6CF"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3363 62.7305H47.8469V65.1528H57.3363V62.7305Z",
    fill: "#98C6CF"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4328 66.0898H46.9442V68.5122H56.4328V66.0898Z",
    fill: "#98C6CF"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1441 69.4492H49.6547V71.8715H59.1441V69.4492Z",
    fill: "#98C6CF"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0445 59.4023H57.5551V61.8247H67.0445V59.4023Z",
    fill: "#98C6CF"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9481 62.7617H58.4586V65.1841H67.9481V62.7617Z",
    fill: "#98C6CF"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0445 66.1211H57.5551V68.5435H67.0445V66.1211Z",
    fill: "#98C6CF"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7557 69.4844H60.2662V71.9067H69.7557V69.4844Z",
    fill: "#98C6CF"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5794 59.4023H78.09V61.8247H87.5794V59.4023Z",
    fill: "#98C6CF"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4824 62.7617H78.9938V65.1841H88.4824V62.7617Z",
    fill: "#98C6CF"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5794 66.1211H78.09V68.5435H87.5794V66.1211Z",
    fill: "#98C6CF"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M90.291 69.4844H80.8015V71.9067H90.291V69.4844Z",
    fill: "#98C6CF"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M97.972 59.3672H88.4825V61.7895H97.972V59.3672Z",
    fill: "#98C6CF"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8756 62.7305H89.3861V65.1528H98.8756V62.7305Z",
    fill: "#98C6CF"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M97.972 66.0898H88.4825V68.5122H97.972V66.0898Z",
    fill: "#98C6CF"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M100.683 69.4492H91.1937V71.8715H100.683V69.4492Z",
    fill: "#98C6CF"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0546 7.05078H40.4027V18.6921H97.0546V7.05078Z",
    fill: "#E9F3F5"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7944 10.8931L58.4072 11.3567C58.02 11.0216 57.6622 10.8771 57.2372 10.8771C56.724 10.8771 56.3141 11.1333 56.3141 11.6599C56.3141 12.1236 56.5148 12.347 57.4387 12.651C58.2577 12.9215 58.9573 13.2659 58.9573 14.3191C58.9573 15.2775 58.2795 15.9477 57.1255 15.9477C56.388 15.9477 55.8076 15.684 55.3834 15.2363L55.7782 14.766C56.1579 15.1095 56.5602 15.3254 57.1187 15.3254C57.7218 15.3254 58.2215 15.0054 58.2215 14.3427C58.2215 13.8076 57.983 13.5682 57.112 13.281C56.1142 12.9526 55.5926 12.5461 55.5926 11.691C55.5926 10.8452 56.2629 10.2539 57.2086 10.2539C57.9158 10.2539 58.3618 10.4782 58.7944 10.8931Z",
    fill: "#4D7479"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1262 16.365C56.3081 16.365 55.6009 16.0735 55.0785 15.5225L54.8214 15.2512L55.7361 14.1585L56.0603 14.4516C56.4139 14.7725 56.7205 14.9027 57.1186 14.9027C57.374 14.9027 57.8015 14.8296 57.8015 14.3399C57.8015 14.0871 57.8015 13.9477 56.9809 13.6772C56.0872 13.3832 55.1733 12.9171 55.1733 11.6891C55.1733 10.6132 56.0301 9.83203 57.2093 9.83203C57.9728 9.83203 58.5347 10.0588 59.0865 10.588L59.3688 10.8592L58.4566 11.9512L58.1332 11.6715C57.8241 11.4035 57.5646 11.2943 57.2387 11.2943C56.9053 11.2943 56.7356 11.417 56.7356 11.6572C56.7356 11.8487 56.7356 11.9747 57.5714 12.2493C58.203 12.4576 59.378 12.8465 59.378 14.3164C59.3772 15.5418 58.4726 16.365 57.1262 16.365Z",
    fill: "#4D7479"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2178 10.7965L62.8306 11.2837C62.5106 11.004 62.1981 10.8763 61.8403 10.8763C61.0659 10.8763 60.4183 11.4357 60.4183 13.0971C60.4183 14.6862 61.0365 15.3086 61.8336 15.3086C62.3174 15.3086 62.6298 15.0776 62.9205 14.8449L63.2783 15.3321C63.0028 15.6437 62.5038 15.9469 61.8117 15.9469C60.5687 15.9469 59.6666 14.9482 59.6666 13.0971C59.6666 11.2366 60.6342 10.2539 61.7958 10.2539C62.4442 10.2531 62.8087 10.4454 63.2178 10.7965Z",
    fill: "#4D7479"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8118 16.365C60.2537 16.365 59.2467 15.0816 59.2467 13.0951C59.2467 10.8408 60.5267 9.83203 61.7958 9.83203C62.5803 9.83203 63.0406 10.0899 63.4908 10.4763L63.7982 10.74L62.8852 11.889L62.5534 11.5984C62.3099 11.3859 62.0965 11.2952 61.8395 11.2952C61.1743 11.2952 60.8375 11.9016 60.8375 13.096C60.8375 13.9132 61.0097 14.8875 61.8328 14.8875C62.1663 14.8875 62.3855 14.733 62.6576 14.5163L62.9994 14.2433L63.8167 15.3562L63.5924 15.6099C63.3917 15.8358 62.8147 16.365 61.8118 16.365Z",
    fill: "#4D7479"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0405 13.2706H64.8811V15.8491H64.1738V10.3477H64.8811V12.6474H67.0405V10.3477H67.7477V15.8491H67.0405V13.2706Z",
    fill: "#4D7479"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1677 16.2672H66.6206V13.6886H65.3011V16.2672H63.7539V9.92578H65.3011V12.2263H66.6206V9.92578H68.1677V16.2672Z",
    fill: "#4D7479"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2382 13.1038C73.2382 14.9247 72.3588 15.9469 71.0712 15.9469C69.7903 15.9469 68.9042 14.9566 68.9042 13.1121C68.9042 11.2996 69.7903 10.2539 71.0712 10.2539C72.3588 10.2531 73.2382 11.2517 73.2382 13.1038ZM69.6567 13.1113C69.6567 14.7005 70.2371 15.3237 71.072 15.3237C71.9354 15.3237 72.4873 14.7005 72.4873 13.1029C72.4873 11.5222 71.9506 10.8754 71.072 10.8754C70.2153 10.8754 69.6567 11.523 69.6567 13.1113Z",
    fill: "#4D7479"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0712 16.365C69.4754 16.365 68.4843 15.1185 68.4843 13.1103C68.4843 11.1188 69.4997 9.83203 71.0712 9.83203C72.6662 9.83203 73.6582 11.0852 73.6582 13.1027C73.6582 15.0849 72.6427 16.365 71.0712 16.365ZM71.0712 11.2943C70.8251 11.2943 70.0759 11.2943 70.0759 13.1103C70.0759 14.9027 70.8251 14.9027 71.0712 14.9027C71.3434 14.9027 72.0665 14.9026 72.0665 13.1019C72.0665 11.2943 71.3434 11.2943 71.0712 11.2943Z",
    fill: "#4D7479"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M78.393 13.1038C78.393 14.9247 77.5144 15.9469 76.2268 15.9469C74.9459 15.9469 74.0598 14.9566 74.0598 13.1121C74.0598 11.2996 74.9459 10.2539 76.2268 10.2539C77.5144 10.2531 78.393 11.2517 78.393 13.1038ZM74.8116 13.1113C74.8116 14.7005 75.3919 15.3237 76.2268 15.3237C77.0903 15.3237 77.6421 14.7005 77.6421 13.1029C77.6421 11.5222 77.1054 10.8754 76.2268 10.8754C75.3701 10.8754 74.8116 11.523 74.8116 13.1113Z",
    fill: "#4D7479"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2269 16.365C74.6319 16.365 73.6399 15.1185 73.6399 13.1103C73.6399 11.1188 74.6554 9.83203 76.2269 9.83203C77.8227 9.83203 78.813 11.0852 78.813 13.1027C78.813 15.0849 77.7975 16.365 76.2269 16.365ZM76.2269 11.2943C75.9808 11.2943 75.2316 11.2943 75.2316 13.1103C75.2316 14.9027 75.9808 14.9027 76.2269 14.9027C76.499 14.9027 77.2222 14.9026 77.2222 13.1019C77.2213 11.2943 76.499 11.2943 76.2269 11.2943Z",
    fill: "#4D7479"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2575 15.1864H82.3648L82.2825 15.8491H79.5494V10.3477H80.2575V15.1864Z",
    fill: "#4D7479"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6538 16.2672H79.1295V9.92578H80.6775V14.7646H82.8394L82.6538 16.2672Z",
    fill: "#4D7479"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8646 29.8516H41.4384V41.4845H52.8646V29.8516Z",
    fill: "#B0BABA"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4616 29.8516L41.4384 34.8121V39.9491L52.8646 34.1923V29.8516H50.4616Z",
    fill: "#F3F5F5"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4387 40.6012L52.865 34.9023V35.9363L41.4387 41.4865V40.6012Z",
    fill: "#F3F5F5"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5479 29.8516H46.6156V41.4845H47.5479V29.8516Z",
    fill: "#F7A47A"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8646 35.2266H41.4384V36.1715H52.8646V35.2266Z",
    fill: "#F7A47A"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M52.865 28.8086H41.4387V29.856H52.865V28.8086Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4389 28.8086H40.4025V41.4889H41.4389V28.8086Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M53.969 28.8086H52.8654V41.4889H53.969V28.8086Z",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9688 41.4961H40.4023V42.7324H53.9688V41.4961Z",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M74.604 29.8516H63.1777V41.4845H74.604V29.8516Z",
    fill: "#B0BABA"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2018 29.8516L63.1777 34.8121V39.9491L74.6049 34.1923V29.8516H72.2018Z",
    fill: "#F3F5F5"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1777 40.6012L74.6049 34.9023V35.9363L63.1777 41.4865V40.6012Z",
    fill: "#F3F5F5"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2851 29.8516H68.3528V41.4845H69.2851V29.8516Z",
    fill: "#F7A47A"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M74.604 35.2266H63.1777V36.1715H74.604V35.2266Z",
    fill: "#F7A47A"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M74.604 28.8086H63.1777V29.856H74.604V28.8086Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1775 28.8086H62.141V41.4889H63.1775V28.8086Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7077 28.8086H74.604V41.4889H75.7077V28.8086Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7084 41.4961H62.142V42.7324H75.7084V41.4961Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6834 29.8516H84.2571V41.4845H95.6834V29.8516Z",
    fill: "#B0BABA"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2812 29.8516L84.2571 34.8121V39.9491L95.6842 34.1923V29.8516H93.2812Z",
    fill: "#F3F5F5"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2561 40.6012L95.6832 34.9023V35.9363L84.2561 41.4865V40.6012Z",
    fill: "#F3F5F5"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3654 29.8516H89.4331V41.4845H90.3654V29.8516Z",
    fill: "#F7A47A"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6834 35.2266H84.2571V36.1715H95.6834V35.2266Z",
    fill: "#F7A47A"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6824 28.8086H84.2561V29.856H95.6824V28.8086Z",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2577 28.8086H83.2213V41.4889H84.2577V28.8086Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7869 28.8086H95.6832V41.4889H96.7869V28.8086Z",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7877 41.4961H83.2213V42.7324H96.7877V41.4961Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8651 51.7227H41.4388V63.3556H52.8651V51.7227Z",
    fill: "#B0BABA"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4621 51.7227L41.4388 56.6832V61.8202L52.8651 56.0633V51.7227H50.4621Z",
    fill: "#F3F5F5"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4386 62.4762L52.8649 56.7773V57.8113L41.4386 63.3615V62.4762Z",
    fill: "#F3F5F5"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M47.548 51.7227H46.6157V63.3556H47.548V51.7227Z",
    fill: "#F7A47A"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8649 57.1016H41.4386V58.0465H52.8649V57.1016Z",
    fill: "#F7A47A"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8649 50.6797H41.4386V51.7271H52.8649V50.6797Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4388 50.6797H40.4023V63.36H41.4388V50.6797Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9693 50.6797H52.8656V63.36H53.9693V50.6797Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9687 63.3672H40.4022V64.6035H53.9687V63.3672Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6824 51.7227H84.2561V63.3556H95.6824V51.7227Z",
    fill: "#B0BABA"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2802 51.7227L84.2561 56.6832V61.8202L95.6832 56.0633V51.7227H93.2802Z",
    fill: "#F3F5F5"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2563 62.4762L95.6835 56.7773V57.8113L84.2563 63.3615V62.4762Z",
    fill: "#F3F5F5"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3657 51.7227H89.4333V63.3556H90.3657V51.7227Z",
    fill: "#F7A47A"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6827 57.1016H84.2563V58.0465H95.6827V57.1016Z",
    fill: "#F7A47A"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6827 50.6797H84.2563V51.7271H95.6827V50.6797Z",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2577 50.6797H83.2213V63.36H84.2577V50.6797Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M96.788 50.6797H95.6843V63.36H96.788V50.6797Z",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7878 63.3672H83.2214V64.6035H96.7878V63.3672Z",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9269 48.8594H58.5182V78.8446H79.9269V48.8594Z",
    fill: "#4D7479"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8423 51.4648H62.142V75.8545H76.8423V51.4648Z",
    fill: "#1F8297"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3607 80.2852H82.1936V81.3073H89.3607V80.2852Z",
    fill: "#6A7070"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0158 49.8604L85.06 50.0049L84.0647 42.9453H86.8718L86.0158 49.8604Z",
    fill: "#F26721",
    fillOpacity: 0.4
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7836 42.7609C88.7836 42.8601 88.6895 42.9398 88.5744 42.9398H82.3624C82.2473 42.9398 82.1532 42.8601 82.1532 42.7609C82.1532 42.6618 82.2473 42.582 82.3624 42.582H88.5744C88.6895 42.582 88.7836 42.6618 88.7836 42.7609Z",
    fill: "#6A7070"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4689 40.4141C84.0671 40.4141 82.9307 41.3867 82.9307 42.5869H88.0072C88.0072 41.3875 86.8707 40.4141 85.4689 40.4141Z",
    fill: "#6A7070"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4098 49.7766C87.4098 49.8757 87.3064 49.9555 87.1788 49.9555H83.8174C83.6897 49.9555 83.5864 49.8757 83.5864 49.7766C83.5864 49.6775 83.6897 49.5977 83.8174 49.5977H87.1788C87.3064 49.5977 87.4098 49.6775 87.4098 49.7766Z",
    fill: "#6A7070"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9305 42.9453L84.2744 49.5925H84.9455L83.647 42.9453H82.9305Z",
    fill: "#6A7070"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0314 42.9453L86.6875 49.5925H86.0164L87.3149 42.9453H88.0314Z",
    fill: "#6A7070"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0166 49.7578H85.0608V80.861H86.0166V49.7578Z",
    fill: "#6A7070"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0235 80.2852H46.8564V81.3073H54.0235V80.2852Z",
    fill: "#6A7070"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6784 49.8604L49.7235 50.0049L48.7281 42.9453H51.5352L50.6784 49.8604Z",
    fill: "#F26721",
    fillOpacity: 0.4
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4464 42.7609C53.4464 42.8601 53.3532 42.9398 53.2372 42.9398H47.026C46.9101 42.9398 46.8169 42.8601 46.8169 42.7609C46.8169 42.6618 46.9101 42.582 47.026 42.582H53.2372C53.3532 42.582 53.4464 42.6618 53.4464 42.7609Z",
    fill: "#6A7070"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M50.132 40.4141C48.7301 40.4141 47.5938 41.3867 47.5938 42.5869H52.6702C52.6702 41.3875 51.5338 40.4141 50.132 40.4141Z",
    fill: "#6A7070"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0733 49.7766C52.0733 49.8757 51.97 49.9555 51.8423 49.9555H48.481C48.3533 49.9555 48.25 49.8757 48.25 49.7766C48.25 49.6775 48.3533 49.5977 48.481 49.5977H51.8423C51.97 49.5977 52.0733 49.6775 52.0733 49.7766Z",
    fill: "#6A7070"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5938 42.9453L48.9368 49.5925H49.6087L48.3102 42.9453H47.5938Z",
    fill: "#6A7070"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6945 42.9453L51.3507 49.5925H50.6787L51.9772 42.9453H52.6945Z",
    fill: "#6A7070"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6795 49.7578H49.7236V80.861H50.6795V49.7578Z",
    fill: "#6A7070"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M101.666 26.5586L135.261 75.9351L101.565 75.7881L101.666 26.5586Z",
    fill: "#4D7479"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M115.649 31.9258H106.949V40.7827H115.649V31.9258Z",
    fill: "#B0BABA"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M113.82 31.9258L106.949 35.7029V39.6144L115.649 35.2309V31.9258H113.82Z",
    fill: "#F3F5F5"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M106.949 40.1086L115.648 35.7695V36.5565L106.949 40.7822V40.1086Z",
    fill: "#F3F5F5"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M111.599 31.9258H110.89V40.7827H111.599V31.9258Z",
    fill: "#F7A47A"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M115.649 36.0117H106.949V36.7315H115.649V36.0117Z",
    fill: "#F7A47A"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M115.648 31.1445H106.948V31.9425H115.648V31.1445Z",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M106.949 31.1445H106.161V40.7994H106.949V31.1445Z",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M116.489 31.1445H115.649V40.7994H116.489V31.1445Z",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M116.49 40.7852H106.161V41.7267H116.49V40.7852Z",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M115.648 46.0352H106.948V54.8921H115.648V46.0352Z",
    fill: "#B0BABA"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M113.819 46.0352L106.948 49.8123V53.7238L115.648 49.3403V46.0352H113.819Z",
    fill: "#F3F5F5"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M106.948 54.2219L115.648 49.8828V50.6698L106.948 54.8955V54.2219Z",
    fill: "#F3F5F5"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M111.599 46.0352H110.889V54.8921H111.599V46.0352Z",
    fill: "#F7A47A"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M115.649 50.1211H106.949V50.8401H115.649V50.1211Z",
    fill: "#F7A47A"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M115.648 45.2539H106.948V46.0518H115.648V45.2539Z",
    fill: "white"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M106.949 45.2539H106.161V54.9088H106.949V45.2539Z",
    fill: "white"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M116.489 45.2539H115.649V54.9088H116.489V45.2539Z",
    fill: "white"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M116.49 54.8945H106.161V55.8361H116.49V54.8945Z",
    fill: "white"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M115.648 60.1484H106.948V69.0054H115.648V60.1484Z",
    fill: "#B0BABA"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M113.819 60.1484L106.948 63.9256V67.8371L115.648 63.4535V60.1484H113.819Z",
    fill: "#F3F5F5"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M106.948 68.3156L115.648 63.9766V64.7636L106.948 68.9892V68.3156Z",
    fill: "#F3F5F5"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M111.599 60.1484H110.889V69.0054H111.599V60.1484Z",
    fill: "#F7A47A"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M115.648 64.2383H106.948V64.9581H115.648V64.2383Z",
    fill: "#F7A47A"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M115.648 59.3477H106.948V60.1456H115.648V59.3477Z",
    fill: "white"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M106.949 59.3477H106.161V69.0026H106.949V59.3477Z",
    fill: "white"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M116.489 59.3477H115.649V69.0026H116.489V59.3477Z",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M116.49 69.0078H106.16V69.9493H116.49V69.0078Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitutions);
export default __webpack_public_path__ + "static/media/institutions.f2415a5bd66bfd6b43fffd2adc3e6dae.svg";
export { ForwardRef as ReactComponent };